import * as fromColorPalette from './color-palette.reducer';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { OrgTypes } from '@mode/shared/contract-common';

export const selectPaletteFeature = createFeatureSelector<fromColorPalette.State>(
  fromColorPalette.colorPaletteFeatureKey
);

export const selectPalettes = createSelector(selectPaletteFeature, (state) => state.colorPalettes);

export const selectDefaultPalettes = createSelector(selectPalettes, (palettes) => {
  const defaultArray = palettes?.filter((p) => p.isDefault) || [];

  // Note that sequential palettes are currently not supported in Mode
  if (defaultArray.length === 0 && (palettes?.length ?? 0) > 0) {
    const defaults = {
      categorical: null as unknown,
      divergent: null as unknown,
      sequential: null as unknown,
    };

    // Go in reverse order so it's easier to store the first of each type
    for (let ii = (palettes?.length ?? 0) - 1; ii--; ii >= 0) {
      switch (palettes?.[ii].type) {
        case 'divergent':
          defaults.divergent = palettes[ii];
          break;
        case 'categorical':
          defaults.categorical = palettes[ii];
          break;
        case 'sequential':
          defaults.sequential = palettes[ii];
          break;
      }
    }

    // Assume defaults are filled because Mode defaults should be present
    return defaults as OrgTypes.DefaultPalettes;
  } else {
    return {
      categorical: defaultArray.find((p) => p.type === OrgTypes.ColorPaletteType.Categorical),
      divergent: defaultArray.find((p) => p.type === OrgTypes.ColorPaletteType.Divergent),
      sequential: defaultArray.find((p) => p.type === OrgTypes.ColorPaletteType.Sequential),
    } as OrgTypes.DefaultPalettes;
  }
});
